// ============ shared DOM element references ============
// Module scripts are deferred, so the DOM is parsed before this runs.
// Elements used by more than one module are grabbed once here; elements local
// to a single module are grabbed inside that module.
const $ = <T extends Element = HTMLElement>(id: string) =>
  document.getElementById(id) as unknown as T;

export const mapDiv     = $('map');
export const sunEl      = $('sun');
export const moonEl     = $('moon');
export const labelsDiv  = $('labels');
export const poiLabelsDiv = $('poiLabels');
export const minimapDiv = $('minimap');
export const statusEl   = $('status');
export const subjEl     = $<HTMLSelectElement>('subject');
export const viewsEl    = $('views');
export const cammodeEl  = $('cammode');
export const traceEl    = $<HTMLSelectElement>('trace');
export const trailFxEl  = $<HTMLSelectElement>('trailFx');
export const smoothBtn  = $<HTMLButtonElement>('smoothBtn');
export const compBtn    = $<HTMLButtonElement>('compBtn');
export const bankBtn    = $<HTMLButtonElement>('bankBtn');
export const soundBtn   = $<HTMLButtonElement>('soundBtn');
export const anonBtn    = $<HTMLButtonElement>('anonBtn');
export const polarBtn   = $<HTMLButtonElement>('polarBtn');
export const polarReset = $<HTMLButtonElement>('polarReset');
export const polarName  = $('polarName');
export const polarRow   = $('polarRow');
export const plrInput   = $<HTMLInputElement>('plrInput');
export const nettoBtn   = $<HTMLButtonElement>('nettoBtn');
export const trafficModeEl = $<HTMLSelectElement>('trafficMode');
export const trafficCanvas = $<HTMLCanvasElement>('trafficCanvas');
export const graphModeEl= $<HTMLSelectElement>('graphMode');
export const graphClose = $<HTMLButtonElement>('graphClose');
export const graphCanvas= $<HTMLCanvasElement>('graphCanvas');
export const graphTabs  = $('graphTabs');
export const winEl      = $<HTMLInputElement>('win');
export const winval     = $('winval');
export const playBtn    = $<HTMLButtonElement>('play');
export const revBtn     = $<HTMLButtonElement>('rev');
export const segEl      = $('speeds');
export const exoEl      = $<HTMLInputElement>('exo');
export const exval      = $('exval');
export const groundEl   = $<HTMLInputElement>('ground');
export const groundval  = $('groundval');
export const cacheEl    = $<HTMLInputElement>('cachesz');
export const cacheval   = $('cacheszval');
export const acscaleEl  = $<HTMLInputElement>('acscale');
export const acscaleval = $('acscaleval');
export const coneBtn    = $<HTMLButtonElement>('coneBtn');
export const finesseEl  = $<HTMLInputElement>('finesse');
export const finval     = $('finval');
export const safetyEl    = $<HTMLInputElement>('safety');
export const safeval    = $('safeval');
export const coneRadEl  = $<HTMLInputElement>('conerad');
export const coneradval = $('coneradval');
export const labelsBtn  = $<HTMLButtonElement>('labelsBtn');
export const labelFieldsEl = $('labelFields');
export const shadowsEl  = $<HTMLSelectElement>('shadows');
export const basemapEl  = $<HTMLSelectElement>('basemap');
export const ignDemBtn  = $<HTMLButtonElement>('ignDemBtn');
export const peaksBtn   = $<HTMLButtonElement>('peaksBtn');
export const minimapBtn = $<HTMLButtonElement>('minimapBtn');
export const overviewHudBtn = $<HTMLButtonElement>('overviewHudBtn');
export const activeOnlyBtn = $<HTMLButtonElement>('activeOnlyBtn');
export const heightRefEl = $<HTMLSelectElement>('heightRef');
export const airMassBtn = $<HTMLButtonElement>('airMassBtn');
export const thermalBtn = $<HTMLButtonElement>('thermalBtn');
export const liftComps  = $('liftComps');   // container for the lift-component checkboxes
export const dayStruct  = $('dayStruct');    // day-structure panel (emagram + summary)
export const wxSimBtn   = $<HTMLButtonElement>('wxSimBtn');
export const wxSimPanel  = $('wxSimPanel');   // weather-sandbox sliders
export const windModeEl = $<HTMLSelectElement>('windMode');
export const windArrow  = $<SVGGElement>('windArrow');
export const windSpd    = $('windSpd');
export const windDir    = $('windDir');
export const clearWpBtn = $<HTMLButtonElement>('clearWpBtn');
export const peakDensityEl = $<HTMLInputElement>('peakDensity');
export const colsBtn    = $<HTMLButtonElement>('colsBtn');
export const buildingsBtn = $<HTMLButtonElement>('buildingsBtn');
export const heatStoreEl = $<HTMLInputElement>('heatStore');
export const attribEl   = $('attribution');
export const curtainBtn = $<HTMLButtonElement>('curtainBtn');
export const attrBtn    = $<HTMLButtonElement>('attrBtn');
export const pitchEl    = $<HTMLInputElement>('pitch');
export const pitchval   = $('pitchval');
export const scrub      = $<HTMLInputElement>('scrub');
export const scrubMin   = $('scrubMin');
export const scrubMax   = $('scrubMax');
export const clkEl      = $('clk');
export const tzEl       = $('tz');
export const clock12Btn = $<HTMLButtonElement>('clock12Btn');
export const lglist     = $('lglist');
export const focusBadge = $('focusBadge');
export const rose       = $<SVGGElement>('rose');
export const altsl      = $<HTMLInputElement>('altsl');
export const icaoEl     = $<HTMLInputElement>('icao');
export const fblink     = $<HTMLAnchorElement>('fblink');
export const afInfo     = $('afInfo');
export const acEl       = $('aclist');
export const dateEl     = $<HTMLInputElement>('date');
export const loadBtn    = $<HTMLButtonElement>('load');
export const hudreg     = $('hudreg');
export const prevAc     = $<HTMLButtonElement>('prevAc');
export const nextAc     = $<HTMLButtonElement>('nextAc');
export const hudhdg     = $('hudhdg');
export const hudspd     = $('hudspd');
export const hudalt     = $('hudalt');
export const hudwindbarb = $('hudwindbarb');
export const hudwindtxt = $('hudwindtxt');
export const hudvar     = $('hudvar');
export const hudnetto   = $('hudnetto');
export const hudnettoK  = $('hudnettoK');
export const hudsuper   = $('hudsuper');
export const hudsuperK  = $('hudsuperK');
export const langEl     = $<HTMLSelectElement>('lang');
export const discEl     = $<HTMLElement>('disclaimer');
export const infoBtn    = $<HTMLButtonElement>('infoBtn');
export const guideEl    = $<HTMLElement>('guide');
export const guideBody  = $<HTMLElement>('guideBody');
export const guideClose = $<HTMLButtonElement>('guideClose');
export const resetSettingsBtn = $<HTMLButtonElement>('resetSettings');
export const copyBtn    = $<HTMLButtonElement>('copyBtn');
export const exportBtn  = $<HTMLButtonElement>('exportBtn');
export const exportFmtEl = $<HTMLSelectElement>('exportFmt');
export const teleportBtn = $<HTMLButtonElement>('teleportBtn');
export const tpModal    = $('tpModal');
export const tpClose    = $<HTMLButtonElement>('tpClose');
export const tpSug      = $('tpSug');
export const gotoPlaceEl = $<HTMLInputElement>('gotoPlace');
export const gotoAltEl   = $<HTMLInputElement>('gotoAlt');
export const gotoAltLab  = $('gotoAltLab');
export const gotoAglEl   = $<HTMLInputElement>('gotoAgl');
export const gotoHdgEl   = $<HTMLInputElement>('gotoHdg');
export const gotoBtn     = $<HTMLButtonElement>('gotoBtn');
export const shareBtn   = $<HTMLButtonElement>('shareBtn');
export const collapseBtn= $<HTMLButtonElement>('collapseBtn');
export const liveBtn    = $<HTMLButtonElement>('liveBtn');
export const igcBtn     = $<HTMLButtonElement>('igcBtn');
export const discoverBtn = $<HTMLButtonElement>('discoverBtn');
export const igcInput   = $<HTMLInputElement>('igcInput');
